import AbstractFilterMethods from '@fr/vue/components/filters/common/filterMethods/filterAttributeMethodsAbstract/FilterAttributeMethodsAbstract';
import { IHotel, RenovationType } from '@entities/hotel';
import { RenovationFilterItem } from '../types';

const data: RenovationFilterItem[] = [
    {
        id: RenovationType.RecentlyOpened,
        key: RenovationType.RecentlyOpened,
        keyMerged: RenovationType.RecentlyOpened,
        name: 'Недавно открылись',
    },
    {
        id: RenovationType.FreshRenovation,
        key: RenovationType.FreshRenovation,
        keyMerged: RenovationType.FreshRenovation,
        name: 'После реновации',
    },
];

export default class RenovationFilterMethods extends AbstractFilterMethods<RenovationFilterItem, IHotel> {
    getCountAttribute(entities: IHotel[]): Record<RenovationFilterItem['key'], number> {
       return entities.reduce((acc, hotel) => {
        hotel.renovationTypes.forEach((type) => {
            acc[type]++;
        })
        return acc;
       }, this.getAttributeObjectCount());
    }

    getIsOneHotelHasProperty(entities: IHotel[]): boolean {
        return entities.some(hotel => {
            return hotel.renovationTypes.length;
        });
      
    }
}
const renovationFilterMethods = new RenovationFilterMethods(data)
    .setFilterName('Открытие и реновация');

export {
    renovationFilterMethods,
};
